// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldset-form{
    margin-top: 20px;
}

.mat-mdc-raised-button>.mat-icon{
    width: 36px;
    height: 36px;
    padding: 5px;
}

@media (max-width:576px) {
    .container input.form-control{
      margin-bottom: 5px;
    }
    .mat-mdc-dialog-actions .mat-mdc-button-base + .mat-mdc-button-base {
        margin-left: 0 !important;
    }
    .margencorector{
      margin-top: 10px;
    }
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
